<!-- 产品资料 -->
<template>
    <div class="product-material-container">
      <div class="product-video" v-show="productMaterial.video.length != 0">
        <h3 class="h3-title"><span>产品视频</span></h3>
        <div class="video-container">
<!--          :poster="cdnUrl.cdnUrl+JSON.parse(productMaterial.video[0].img_url)[0]"-->
          <div class="single-video" v-if="productMaterial.video.length == 1">
            <video v-if="!productMaterial.video[0].redirect_url" id="aboutType1_video" ref="aboutType1_video" class="video" :poster="cdnUrl.cdnUrl+JSON.parse(productMaterial.video[0].img_url)[0]" controls x5-video-player-type="h5" playsinline webkit-playsinline>
              <source :src="cdnUrl.cdnUrl+JSON.parse(productMaterial.video[0].video_url)[0]" type="video/mp4">
            </video>
            <!-- 单个图片链接 -->
            <img v-if="productMaterial.video[0].redirect_url" class="video" @click="gotoDetail(productMaterial.video[0].redirect_url)" :src="cdnUrl.cdnUrl+JSON.parse(productMaterial.video[0].img_url)[0]" alt="">
            <div class="video-title">{{productMaterial.video[0].title}}</div>
          </div>
<!--          <div id="dplayer"></div>-->
<!--          <div class="no-data" v-if="productMaterial.video.length == 0">暂且没有产品视频</div>-->
          <div class="video-list" v-if="productMaterial.video.length > 1">
            <div class="video-item" v-for="(item, index) in productMaterial.video" :key="index">
              <div class="video-cover" v-if="!item.redirect_url" @click="clickVideo(item)">
                <van-image class="cover" :src="cdnUrl.cdnUrl+JSON.parse(item.img_url)" fit="cover" alt=""/>
                <i class="iconfont icon-videoplay video-icon"></i>
              </div>
              <!-- 多个图片链接 -->
              <div class="video-cover" v-if="item.redirect_url">
                <van-image class="cover" fit="cover" @click="gotoDetail(item.redirect_url)" :src="cdnUrl.cdnUrl+JSON.parse(item.img_url)" alt=""/>
              </div>
              <div class="video-title van-multi-ellipsis--l2">{{item.title}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="product-pdf" v-show="productMaterial.pdf.length != 0">
        <h3 class="h3-title"><span>PDF 文件</span></h3>
<!--        <div class="no-data" v-if="productMaterial.pdf.length == 0">暂且没有pdf文件</div>-->
        <div class="pdf-list">
          <div class="pdf-item" @click="previewPdf(item)" v-for="(item, index) in productMaterial.pdf" :key="index">
            <div class="pdf-cover">
<!--              <img class="cover" src="@/assets/img/pdf-bg.png" alt="">-->
<!--              <img class="cover" :src="cdnUrl.cdnUrl+item.cover" alt="">-->
              <van-image class="cover" :src="cdnUrl.cdnUrl+item.cover" fit="cover" alt=""/>
              <img class="pdf-icon" src="@/assets/img/pdf.png" alt="">
            </div>
            <div class="pdf-title van-multi-ellipsis--l2">{{item.title}}</div>
          </div>
        </div>
      </div>
      <div class="no-data" v-if="productMaterial.video.length == 0 && productMaterial.pdf.length == 0">暂且没有资料</div>
    </div>
</template>

<script>
  import { recordVideo, recordPdf } from '@/api/product'

  export default {
    data () {
      return {
        cdnUrl: this.$config.baseUrl
      }
    },
    props: {
      id: {
        type: String,
        defalut: ''
      },
      productMaterial: {
        type: Object,
        defalut: {}
      },
      
    },
    created () {

    },
    mounted () {
      // cdnUrl.cdnUrl+JSON.parse(productMaterial.video[0].video_url)[0]
      // var videoUrl = this.cdnUrl.cdnUrl + JSON.parse(this.productMaterial.video[0].video_url)[0]
      // var poster = this.cdnUrl.cdnUrl + JSON.parse(this.productMaterial.video[0].img_url)[0]
      // this.dplayerOption(videoUrl, poster)
      // aboutType1_video
      if (this.$refs.aboutType1_video) {
        this.$nextTick(() => {
        var Media = this.$refs.aboutType1_video
          // Media.eventTester('loadstart')
          Media.addEventListener('play', () => {
            this.record()
          })
        })
      }
      
    },
    methods: {
      gotoDetail (url) {
        window.location.href = url
      },
      // dplayerOption (videoUrl, pic) {
      //   const dp = new DPlayer({
      //     container: document.getElementById('dplayer'),
      //     screenshot: true,
      //     video: {
      //       url: videoUrl,
      //       pic: pic,
      //       thumbnails: 'thumbnails.jpg'
      //     },
      //     subtitle: {
      //       url: 'webvtt.vtt'
      //     },
      //     danmaku: {
      //       id: 'demo',
      //       api: 'https://api.prprpr.me/dplayer/'
      //     }
      //   })
      //   console.log(dp)
      // },
      record () {
        var videoId = this.productMaterial.video[0].id
        // console.log(videoId, 666)
        this.recordVideoPort(videoId)
      },
      clickVideo (item) {
        var videoId = item.id
        this.$emit('videoChange', item)
        this.recordVideoPort(videoId)
      },
      previewPdf (item) {
        console.log(item)
        var id = item.id
        window.location.href = `${this.cdnUrl.pro}/pageTurnings/index.html?id=${item.id}&d=${this.id}&productType=2`
        this.recordPDFPort(id)
      },
      /** 网络请求 **/
      // 记录视频浏览记录
      recordVideoPort (videoId) {
        recordVideo({ id: videoId }).then(res => {
          // console.log(res)
        }).catch(err => {
          console.log('记录视频浏览记录失败', err)
        })
      },
      // 记录PDF浏览记录
      recordPDFPort (pdfId) {
        recordPdf({ id: pdfId }).then(res => {
          console.log(res)
        }).catch(err => {
          console.log('记录pdf浏览记录失败', err)
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
.product-material-container{
  padding: 0 rem(20);
  .no-data{
    font-size: rem(11);
    height: rem(45);
    line-height: rem(45);
    text-align: center;
  }
  .h3-title{
    height: rem(45);
    line-height: rem(45);
    color: #333333;
    font-size: 15px;
    position: relative;
    display: flex;
    align-items: center;
    padding-left: rem(15);
    &:after{
      content: '';
      display: block;
      width: rem(8);
      height: rem(17);
      background: $base-color;
      position: absolute;
      top: 50%;
      left: 0;
      margin-top: rem(-8);
    }
  }
  .product-video{
    .video-container{
      width: 100%;
      .video{
        width: 100%;
      }
      .single-video{
        .video-title{
          margin: 5px 0;
          font-size: rem(12);
        }
      }
    }
  }
  .product-pdf{}
  .video-list{
    padding: 0 rem(15);
    &:after{
      content: '';
      display: block;
      clear: both;
    }
    .video-item{
      margin-bottom: rem(15);
      &:nth-child(odd){
        float: left;
      }
      &:nth-child(even){
        float: right;
      }
      .video-cover{
        width: rem(140);
        height: rem(105);
        background: #cfcfcf;
        border-radius: 4px;
        position: relative;
        overflow: hidden;
        .cover{
          /*width: 100%;*/
          height: 100%;
          border-radius: 4px;
        }
        .pdf-icon{
          position: absolute;
          bottom: rem(9);
          right: rem(11);
          width: rem(20);
          height: rem(27);
          z-index: 1;
        }
        .video-icon{
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          font-size: rem(30);
          color: black;
        }
      }
      .video-title{
        width: rem(120);
        margin-top: rem(5);
        font-size: 13px;
        color: #333;
        text-align: center;
      }
    }
  }
  .pdf-list{
    padding: 0 rem(15);
    &:after{
      content: '';
      display: block;
      clear: both;
    }
    .pdf-item{
      margin-bottom: rem(15);
      height: rem(190);
      &:nth-child(odd){
        float: left;
      }
      &:nth-child(even){
        float: right;
      }
      .pdf-cover{
        width: rem(120);
        height: rem(160);
        background: #cfcfcf;
        border-radius: 4px;
        position: relative;
        overflow: hidden;
        .cover{
          /*width: 100%;*/
          height: 100%;
          border-radius: 4px;
        }
        .pdf-icon{
          position: absolute;
          bottom: rem(9);
          right: rem(11);
          width: rem(20);
          height: rem(27);
          z-index: 1;
        }
        .video-icon{
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          font-size: rem(30);
          color: black;
        }
      }
      .pdf-title{
        width: rem(120);
        margin-top: rem(5);
        font-size: 13px;
        color: #333;
        text-align: center;
      }
    }
  }
}
</style>
